import { render } from "./BrandName.vue?vue&type=template&id=11e94952&scoped=true"
import script from "./BrandName.vue?vue&type=script&lang=js"
export * from "./BrandName.vue?vue&type=script&lang=js"

import "./BrandName.vue?vue&type=style&index=0&id=11e94952&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e94952"]])

export default __exports__